import { ENUM } from "./enum";

const FORMAT_DATE = 'DD/MM/YYYY';
const FORMAT_DATE_TIME = 'DD/MM/YYYY, HH:mm';
const FORMAT_TIME = 'HH:mm';

const FORMAT_DATE_YMD = 'YYYY-MM-DD';

const SELECT_OPTION_LIST = [
  {
    text: 'Move lane',
    value: ENUM.SAMPLE.TEST1,
  },
  {
    text: 'Copy lane',
    value: ENUM.SAMPLE.TEST2,
  },
];

const TEST = 'Test'

const FETCH_STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error'
}

const EXPORT_FORMAT_OPTIONS = [
  {
    text: 'Export to PDF',
    value: ENUM.EXPORT_TYPE.PDF,
  },
  {
    text: 'Export to TXT',
    value: ENUM.EXPORT_TYPE.TXT,
  },
];

const LANGUAGE = {
  EN: 'en',
  TH: 'th'
} as const

const MIME_TYPE = {
  JSON: 'application/json',
  PDF: 'application/pdf',
  TXT: 'text/plain',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  WEBM: 'audio/webm',
  MP3: 'audio/mpeg',
  M4A: 'audio/mp4',
  WAV: 'audio/wav',
  AAC: 'audio/aac',
  VWEBM: 'video/webm',
} as const;

export const DATA = {
  FORMAT_DATE,
  FORMAT_TIME,
  FORMAT_DATE_TIME,
  FORMAT_DATE_YMD,
  SELECT_OPTION_LIST,
  TEST,
  LANGUAGE,
  FETCH_STATUS,
  EXPORT_FORMAT_OPTIONS,
  MIME_TYPE
};

export type ILANGUAGE = (typeof LANGUAGE)[keyof typeof LANGUAGE]
